import React, { useState } from "react";
import InfoSection from "@components/pages/info/info_section";
import ServiceHeader from "@components/pages/info/services/service_header";
import Head from "next/head";
import { WEBPAGE_TITLE } from "@utils/constants";
import { FlexContainer } from "@components/ui/flex_container";
// import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
// import { faChevronLeft, faChevronRight } from "@fortawesome/free-solid-svg-icons";
import "react-responsive-carousel/lib/styles/carousel.min.css"; // requires a loader

// import { Carousel } from "react-responsive-carousel";
import VideoPlayer from "@components/VideoPlayer";
import VideoPreview from "@components/VideoPreview";
import Link from "next/link";
import videoThumb from "public/img/simsvorun/video-thumb.png";
import simsvorunIcon from "public/img/thjonusta/simsvorun.png";

const PACKAGES = [
    {
        backgroundColor: "#E9B36E",
        callCount: 50,
        companySize: "lítil fyrirtæki",
        price: "29.900",
    },
    {
        backgroundColor: "#D36c69",
        callCount: 100,
        companySize: "meðalstór fyrirtæki",
        price: "53.900",
    },
    {
        backgroundColor: "#5b5886",
        callCount: 400,
        companySize: "stór fyrirtæki",
        price: "199.900",
    },
];

// const REVIEWS = [
//     {
//         review: "Við hjá IcePhone ehf erum hæstánægð með símsvörunarþjónustu 1819.is. Hún gerir okkur kleift að einbeita okkur að verkefnum dagsins og kemur skipulagi á fyrirspurnir sem berast í gegnum síma og sparar okkur mikinn tíma. Finnbogi, okkar tengiliður hjá fyrirtækinu er til fyrirmyndar varðandi viðmót og þjónustulund.",
//         reviewer: "Halldór hjá IcePhone",
//         logo: "/img/simsvorun/icephone.png",
//     },
//     {
//         review: "Símsvörunin er frábær.",
//         reviewer: "Prófari hjá 1819",
//         logo: "/img/1819logo-blue.svg",
//     },
//     {
//         review: "Símsvörunin er góð leið til að spara tíma og peninga.",
//         reviewer: "Prófari hjá Torginu",
//         logo: "/img/torgid_logo.png",
//     },
// ];

function ServiceNumber() {
    const [currentVideo, setCurrentVideo] = useState(null);
    return (
        <>
            <Head>
                <title key="site_title">Símsvörun - Af hverju símsvörun? - {WEBPAGE_TITLE}</title>
                <meta
                    name="description"
                    content={`Svörun símtala og annarra miðla skiptir öllu máli fyrir
                        fyrirtæki þar sem hún er fyrsta snerting við viðskiptavin.
                        Þegar sú þjónusta er fyrsta flokks hefur það jákvæð áhrif á
                        framleiðni starfsmanna með því að minnka áreiti. Við hjá
                        1819 erum sérfræðingar í svörun og höfum bæði reynslu og
                        þekkingu til að sinna öllu sem kann að koma upp. Við komum
                        skilaboðum áfram til starfsmanna og viðskiptavina hratt og
                        örugglega. Þannig sjáum við til þess að starfsmenn nái
                        hámarks árangri án truflunar. Við sérsníðum svörun að þínum
                        þörfum alla daga ársins.`}
                    key="description"
                ></meta>
            </Head>
            <VideoPlayer
                video={currentVideo}
                onModalDismiss={() => {
                    setCurrentVideo(null);
                }}
            />
            <InfoSection containerStyle={{ padding: 30 }}>
                <ServiceHeader image={simsvorunIcon} title="Af hverju símsvörun?" />
                <p style={{ fontWeight: 600 }}>
                    Svörun símtala og annarra miðla skiptir öllu máli fyrir fyrirtæki þar sem hún er
                    fyrsta snerting við viðskiptavin. Þegar sú þjónusta er fyrsta flokks hefur það
                    jákvæð áhrif á framleiðni starfsmanna með því að minnka áreiti.
                </p>
                <p>
                    Við hjá 1819 erum sérfræðingar í svörun og höfum bæði reynslu og þekkingu til að
                    sinna öllu sem kann að koma upp. Við komum skilaboðum áfram til starfsmanna og
                    viðskiptavina hratt og örugglega. Þannig sjáum við til þess að starfsmenn nái
                    hámarks árangri án truflunar.
                </p>
                <FlexContainer className="simsvorun-header-info" justifyContent="center">
                    <p style={{ flex: 1 }}>Við sérsníðum svörun að þínum þörfum </p>
                    <div className="simsvorun-header-info-separator horizontal" />
                    <p style={{ flex: 1 }}>Alla daga ársins!</p>
                </FlexContainer>
            </InfoSection>
            <FlexContainer justifyContent="center">
                <Link href="/um/thjonusta/simsvorun/skraning" scroll={false}>
                    <a className="simsvorun-try">
                        <div>Prófaðu símsvörun frítt í viku!</div>
                    </a>
                </Link>
            </FlexContainer>
            <InfoSection containerClassName="simsvorun-video-section">
                <div
                    className="simsvorun-video-container"
                    onClick={() => {
                        setCurrentVideo({
                            link: "https://youtu.be/gIUvnnITGMk",
                            videoTitle: "Símsvörun",
                        });
                    }}
                >
                    <div
                        style={{
                            position: "absolute",
                            zIndex: 2,
                            width: "100%",
                            height: "100%",
                        }}
                        className="d-none d-sm-block"
                    >
                        <h4>Við svörum fyrir þig!</h4>
                    </div>

                    <VideoPreview previewImage={videoThumb} alt="Mynd af þjónustufulltrúa" />
                </div>
                <h3>Kostir símsvörunar</h3>
                <FlexContainer style={{ justifyContent: "center", width: "100%" }}>
                    <FlexContainer column style={{ maxWidth: 500 }}>
                        <FlexContainer
                            className="simsvorun-header-info"
                            justifyContent="center"
                            alignItems="center"
                        >
                            <img
                                alt="Clock Icon Minus"
                                className="info-icon-start"
                                style={{ height: 40 }}
                                src="/img/simsvorun/clock-minus.png"
                            />
                            <p>Minni biðtími</p>
                            <div className="simsvorun-header-info-separator" />
                            <p>Betri þjónusta</p>
                            <img
                                alt="Thumbs Up Icon"
                                className="info-icon-end"
                                style={{ height: 40 }}
                                src="/img/simsvorun/thumb-up.png"
                            />
                        </FlexContainer>

                        <FlexContainer
                            className="simsvorun-header-info"
                            justifyContent="center"
                            alignItems="center"
                        >
                            <p>Meiri tími fyrir önnur verkefni</p>
                            <img
                                alt="Clock Icon Plus"
                                className="info-icon-end"
                                style={{ height: 40 }}
                                src="/img/simsvorun/clock-plus.png"
                            />
                        </FlexContainer>

                        <FlexContainer
                            className="simsvorun-header-info"
                            style={{ alignItems: "end" }}
                            justifyContent="center"
                        >
                            <p>Færri töpuð símtöl</p>
                        </FlexContainer>
                    </FlexContainer>
                </FlexContainer>
            </InfoSection>

            <InfoSection containerClassName="simsvorun-packages-section">
                <h3>Dæmi um verð fyrir símsvörun</h3>
                <FlexContainer className="simsvorun-packages-container">
                    {PACKAGES.map((pack, index) => (
                        <Package key={index} {...pack} />
                    ))}
                </FlexContainer>
                <p style={{ margin: 0, textAlign: "center", color: "#888" }}>
                    Aukagjald er tekið fyrir aðgang og vinnslu í kerfum, t.d. pantana- eða
                    bókunarkerfum.
                </p>
            </InfoSection>

            {/* <InfoSection containerClassName="simsvorun-compare-section">
                <h3>Samanburður</h3>
                <h4>Smelltu á pakka til að bera saman!</h4>
            </InfoSection> */}

            {/* <InfoSection containerClassName="simsvorun-reviews-section">
                <h3>Hvað segja viðskiptavinir okkar?</h3>
                <ReviewsCarousel />
            </InfoSection> */}

            <FlexContainer justifyContent="center">
                <Link href="/um/thjonusta/simsvorun/skraning" scroll={false}>
                    <a className="simsvorun-try">
                        <div>Prófaðu símsvörun frítt í viku!</div>
                    </a>
                </Link>
            </FlexContainer>

            <InfoSection containerClassName="simsvorun-qna-section">
                <h3>Spurt og svarað</h3>
                <h4>(algengar spurningar)</h4>

                <InfoSection
                    collapsible
                    collapsed
                    title="Hvað þarf ég að gera til að koma í símsvörunarþjónustu?"
                >
                    Það eina sem þarf að gera er að gefa okkur helstu upplýsingar.
                </InfoSection>
                <InfoSection collapsible collapsed title="Er hægt að velja opnunartíma?">
                    Já, það er minnsta mál, við getum svarað símanum þegar þér hentar á milli 8 - 21
                    alla daga vikunnar. Þú velur hvaða tíma þú vilt svörun og við tökum þá við
                    símsvörun.
                </InfoSection>
                <InfoSection
                    collapsible
                    collapsed
                    title="Er hægt að velja hvaða símtöl 1819 svarar?"
                >
                    Já, það er hægt. Það er hægt að láta 1819 svara aðeins utan opnunartíma, þegar
                    það eru veikindi eða álagstoppar. Það er líka í boði að láta 1819 svara öllum
                    símtölum. Við getum svarað símanum alla daga ársins á milli 08:00 - 21:00.
                </InfoSection>
                <InfoSection collapsible collapsed title="Bjóðið þið upp á netspjall líka?">
                    Já, það er líka í boði. Þjónustufulltrúar 1819 geta svarað fyrirspurnum á
                    netspjalli og mismunandi samfélagsmiðlum líka.
                </InfoSection>
                <InfoSection
                    collapsible
                    collapsed
                    title="Hvernig getið þið orðið sérfræðingar í mínu fyrirtæki?"
                >
                    Þjónustufulltrúar 1819 eru vel þjálfaðir í að tala í þínu nafni. Við öflum okkur
                    upplýsinga um þitt fyrirtæki í samvinnu við þig, sem gerir okkur auðveldara að
                    búa til ánægða viðskiptavini.
                </InfoSection>
                <InfoSection
                    collapsible
                    collapsed
                    title="Hvernig komið þið skilaboðum áfram til starfsmanna?"
                >
                    Starfsfólki fyrirtækja er alveg frjálst að velja hvort það vilji skilaboð eða fá
                    símtöl send beint til sín, þar sem tekið er fram erindi og nafn viðkomandi.
                    Skilaboðum er síðan hægt að sinna seinna meir, á tíma sem hentar betur.
                </InfoSection>
                <InfoSection collapsible collapsed title="Aðrar upplýsingar">
                    Ef aðrar spurningar vakna má senda okkur tölvupóst á 1819@1819.is og við svörum
                    eins fljótt og hægt er!
                </InfoSection>
            </InfoSection>
        </>
    );
}
export default ServiceNumber;

const Package = ({ callCount, companySize, price, backgroundColor }) => {
    return (
        <FlexContainer className="simsvorun-package-background" style={{ backgroundColor }}>
            <FlexContainer column className="simsvorun-package-container">
                <div className="call-count">{callCount}</div>
                <div className="package-description">símtöl á mánuði</div>
                <div className="package-company-size">fyrir {companySize}</div>
                <div className="package-price">
                    {price}
                    <span>kr.</span>
                </div>
            </FlexContainer>
        </FlexContainer>
    );
};

// const ReviewsCarousel = () => {
//     const [currentReview, setCurrentReview] = useState(0);
//     const updateCurrentSlide = (index) => {
//         if (currentReview !== index) {
//             setCurrentReview(index);
//         }
//     };
//     return (
//         <div style={{ display: "flex" }}>
//             <button
//                 className="carousel-chevron-prev"
//                 style={{ flex: 1 }}
//                 onClick={() => {
//                     setCurrentReview(currentReview - 1);
//                 }}
//             >
//                 <FontAwesomeIcon icon={faChevronLeft} />
//             </button>
//             <Carousel
//                 style={{ flexShrink: 1 }}
//                 autoPlay
//                 interval={10000}
//                 infiniteLoop
//                 showThumbs={false}
//                 showStatus={false}
//                 showIndicators={false}
//                 showArrows={false}
//                 selectedItem={currentReview}
//                 onChange={updateCurrentSlide}
//             >
//                 {REVIEWS.map((review, index) => (
//                     <Review key={index} {...review} />
//                 ))}
//             </Carousel>
//             <button
//                 className="carousel-chevron-next"
//                 style={{ flex: 1 }}
//                 onClick={() => {
//                     setCurrentReview(currentReview + 1);
//                 }}
//             >
//                 <FontAwesomeIcon icon={faChevronRight} />
//             </button>
//         </div>
//     );
// };

// const Review = ({ review, reviewer, logo }) => {
//     return (
//         <div>
//             <p className="simsvorun-review">„{review}“</p>
//             <p className="simsvorun-reviewer">— {reviewer}</p>
//             <img src={logo} alt="Company Logo" />
//         </div>
//     );
// };
